
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/aiAssistantPanel/assistant/widgets/widgets/shared/CardLayout/CardLayout.module.scss.css.virtualfile';
        module.exports = {"container":"_container_1bjds_1","containerDark":"_containerDark_1bjds_8"};